import { v2 } from '@saucelabs/sl-module-builds';

export const NAMESPACE = 'flatBuildsRDC';

export const rdcBuildsV2Types = v2.buildsList.types.createRDCTypes(NAMESPACE);
